export interface IRouteResponse {
  routes: {
    distanceMeters: number;
    duration: string;
  }[];
}
